/** Год документа: из поля year или из date (SAZD-вложенные законы часто без year). */
export const getDocYear = doc => {
	if (doc?.year != null && doc.year !== '') {
		return Number(doc.year);
	}
	if (doc?.date) {
		return new Date(doc.date).getFullYear();
	}
	return null;
};

/**
 * Сортировка по дате (новые первые), группировка по полю year, годы по убыванию.
 * listStart — значение для атрибута start у <ol> при сквозной нумерации по всем годам.
 */
export const buildDeputyDocYearSections = (items) => {
	if (!items || items.length === 0) {
		return [];
	}
	const sorted = [...items].sort((a, b) => new Date(b.date) - new Date(a.date));
	const byYear = new Map();
	for (const item of sorted) {
		const y = getDocYear(item);
		if (y == null) continue;
		if (!byYear.has(y)) {
			byYear.set(y, []);
		}
		byYear.get(y).push(item);
	}
	const yearsDesc = [...byYear.keys()].sort((a, b) => Number(b) - Number(a));
	let cumulative = 0;
	return yearsDesc.map((year) => {
		const sectionItems = byYear.get(year);
		const listStart = cumulative + 1;
		cumulative += sectionItems.length;
		return { year, items: sectionItems, listStart };
	});
};

// Я знаю, что это колхоз, но просидев 3 часа над размышлениями как сделать упорядоченный список у разных элементов - я понял, что это единственный выход
export const getStartNumDeputyLaws = (laws, i, arr) => {
	if (!i) {
		return 1;
	} else if (i === 1) {
		return laws[Object.keys(laws)[arr.length - 1]].length + 1;
	} else if (i === 2) {
		return laws[Object.keys(laws)[arr.length - 1]].length + laws[Object.keys(laws)[arr.length - 2]].length + 1;
	} else if (i === 3) {
		return laws[Object.keys(laws)[arr.length - 1]].length + laws[Object.keys(laws)[arr.length - 2]].length + laws[Object.keys(laws)[arr.length - 3]].length + 1;
	} else if (i === 4) {
		return laws[Object.keys(laws)[arr.length - 1]].length + laws[Object.keys(laws)[arr.length - 2]].length + laws[Object.keys(laws)[arr.length - 3]].length + laws[Object.keys(laws)[arr.length - 4]].length + 1;
	} else if (i === 5) {
		return laws[Object.keys(laws)[arr.length - 1]].length + laws[Object.keys(laws)[arr.length - 2]].length + laws[Object.keys(laws)[arr.length - 3]].length + laws[Object.keys(laws)[arr.length - 4]].length + laws[Object.keys(laws)[arr.length - 5]].length + 1;
	}
};
